// extracted by mini-css-extract-plugin
module.exports = {"cpInfo":"cpInfo_cpInfo__tSVfo","introduction":"cpInfo_introduction__MDTCA","tagBar":"cpInfo_tagBar__1ZMyz","tag":"cpInfo_tag__chknf"};